/**
 * Creates a link component that passes a predefined value to predefined form field
 *
 * @prop {bool} editing - Indicated whether the user is in editing mode
 * @prop {object} input - Contains the current value for the field and onChange method for changing the value
 * @prop {function} localeMessage - Changes message id to corresponding locale string
 * @prop {string || int} linkValue - Value to be passed to form
 * @prop {string} linkText - Text displayed in the link
 *
 * @returns Link, with onClick function to change field value
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import classes from './LinkValueInput.less';

const LinkValueInput = ({ editing, input, localeMessage, linkValue, linkText }) =>
  editing ? (
    <Row middle="xs" className={classes.linkContainer}>
      <Col xs>
        <a className={classes.linkText} onClick={e => input.onChange(linkValue)}>
          {localeMessage(linkText)}
        </a>
      </Col>
    </Row>
  ) : null;

LinkValueInput.propTypes = {
  editing: PropTypes.bool,
  input: PropTypes.object,
  localeMessage: PropTypes.func,
  linkValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkText: PropTypes.string,
};

export default LinkValueInput;
